export const messages = {
  en: {
    invoiceApply: {
      searchTitle: 'Search Conditions',
      title: 'Invoicing',
      apply: 'Invoicing',
      table: {
        id: 'ID',
        invoiceKind: 'Invoice Kind',
        invoiceType: 'Invoice Type',
        ownerName: 'Owner Name',
        roomName: 'Room No.',
        applicant: 'Applicant',
        invoiceName: 'Invoice Title',
        taxNumber: 'Taxpayer ID',
        addressPhone: 'Address & Phone',
        amount: 'Amount',
        invoiceCode: 'Invoice Code',
        submitState: 'Submit Result',
        mallState: 'Mall Status',
        failReason: 'Fail Reason',
        applyTime: 'Apply Time',
        invoicePdf: 'Invoice PDF'
      },
      mallState: {
        AUDIT: 'Pending Audit',
        WAIT: 'Pending Issue',
        DONE: 'Issued',
        FAIL: 'Issue Failed',
        RED: 'Red Invoiced'
      },
      submitStateAll: 'All',
      submitStateSubmit: 'Submitted',
      submitStateFail: 'Submit Failed',
      personal: 'Personal',
      company: 'Company',
      invoiceKindAll: 'All',
      invoiceTypeAll: 'All',
      normalInvoice: 'Normal Invoice',
      specialInvoice: 'Special VAT Invoice',
      notUploaded: 'Not Uploaded',
      downloadInvoice: 'Download Invoice',
      noInvoicePdf: 'No Invoice PDF',
      reSubmit: 'Re-submit',
      submitSuccess: 'Submitted',
      submitFailed: 'Submit failed',
      invoiceCodePlaceholder: 'Please enter invoice number',
      invoiceKindPlaceholder: 'Please select invoice kind',
      invoiceTypePlaceholder: 'Please select invoice type',
      ownerNamePlaceholder: 'Please enter owner name',
      applicantPlaceholder: 'Please enter applicant',
      phonePlaceholder: 'Please enter applicant phone',
      roomNamePlaceholder: 'Please enter room number',
      roomFilterTitle: 'Room Filter',
      allRooms: 'All Rooms',
      tabInvoice: 'Invoice Management',
      tabInvoiceRed: 'Invoice Red',
      invoiceRed: 'Red',
      redTitle: 'Invoice Red List',
      redDialogTitle: 'Issue Red Invoice',
      redReason: 'Red Reason',
      redReasonPlaceholder: 'Please select red reason',
      redReasonRequired: 'Please select red reason',
      redReasonOptions: {
        invoiceError: 'Invoice Error',
        salesReturn: 'Sales Return',
        serviceStop: 'Service Terminated',
        other: 'Other'
      },
      redRemark: 'Remark',
      redRemarkPlaceholder: 'Please enter remark (optional)',
      confirmRed: 'Confirm Red',
      redSuccess: 'Red invoice application submitted',
      redFailed: 'Red invoice not finished, please retry in mall',
      redEmptyTip: 'No red invoice data',
      redState: {
        WAIT: 'Pending Red',
        DONE: 'Red Issued'
      },
      redTable: {
        applyId: 'Apply ID',
        redId: 'Red ID',
        invoiceNo: 'Invoice No.',
        buyerName: 'Buyer',
        amount: 'Red Amount',
        reason: 'Red Reason',
        remark: 'Remark',
        state: 'Status',
        redNo: 'Red Invoice No.',
        createTime: 'Time'
      }
    },
    deleteInvoiceApply: {
      title: 'Confirm Operation',
      confirmMessage: 'Confirm to delete this invoice application?'
    },
    uploadImage: {
      sizeLimit: 'Image size cannot exceed 2MB'
    }
  },
  zh: {
    invoiceApply: {
      searchTitle: '查询条件',
      title: '开票',
      apply: '开票',
      table: {
        id: '编号',
        invoiceKind: '发票种类',
        invoiceType: '发票类型',
        ownerName: '业主名称',
        roomName: '房屋编号',
        applicant: '申请人',
        invoiceName: '发票名头',
        taxNumber: '纳税人识别号',
        addressPhone: '地址、电话',
        amount: '申请金额',
        invoiceCode: '发票号',
        submitState: '提交结果',
        mallState: '商城状态',
        failReason: '失败原因',
        applyTime: '申请时间',
        invoicePdf: '发票PDF'
      },
      mallState: {
        AUDIT: '待审核',
        WAIT: '待开票',
        DONE: '开票成功',
        FAIL: '开票失败',
        RED: '已冲红'
      },
      submitStateAll: '全部',
      submitStateSubmit: '已提交',
      submitStateFail: '提交失败',
      personal: '个人',
      company: '企业',
      invoiceKindAll: '全部',
      invoiceTypeAll: '全部',
      normalInvoice: '普票',
      specialInvoice: '专票',
      notUploaded: '未上传',
      downloadInvoice: '下载发票',
      noInvoicePdf: '暂无发票',
      reSubmit: '重新提交',
      submitSuccess: '已提交',
      submitFailed: '提交失败',
      invoiceCodePlaceholder: '请填写发票号',
      invoiceKindPlaceholder: '请选择发票种类',
      invoiceTypePlaceholder: '请选择发票类型',
      ownerNamePlaceholder: '请填写业主名称',
      applicantPlaceholder: '请填写申请人',
      phonePlaceholder: '请填写申请人电话',
      roomNamePlaceholder: '请填写房屋编号',
      roomFilterTitle: '房屋筛选',
      allRooms: '全部房屋',
      tabInvoice: '发票管理',
      tabInvoiceRed: '发票红冲',
      invoiceRed: '红冲',
      redTitle: '发票红冲列表',
      redDialogTitle: '发起红冲',
      redReason: '红冲原因',
      redReasonPlaceholder: '请选择红冲原因',
      redReasonRequired: '请选择红冲原因',
      redReasonOptions: {
        invoiceError: '开票有误',
        salesReturn: '销售退回',
        serviceStop: '服务终止',
        other: '其他'
      },
      redRemark: '备注',
      redRemarkPlaceholder: '请填写备注(选填)',
      confirmRed: '确认红冲',
      redSuccess: '红冲申请已提交',
      redFailed: '红冲未完成, 可在商城后台重试',
      redEmptyTip: '暂无红冲数据',
      redState: {
        WAIT: '待冲红',
        DONE: '已冲红'
      },
      redTable: {
        applyId: '申请单号',
        redId: '红冲单号',
        invoiceNo: '发票号码',
        buyerName: '购买方',
        amount: '红冲金额',
        reason: '红冲原因',
        remark: '备注',
        state: '状态',
        redNo: '红字发票号码',
        createTime: '时间'
      }
    },
    deleteInvoiceApply: {
      title: '请确认您的操作',
      confirmMessage: '确定删除申请发票'
    },
    uploadImage: {
      sizeLimit: '图片大小不能超过 2MB'
    }
  },
  'zh-TW': {
    invoiceApply: {
      searchTitle: '查詢條件',
      title: '開票',
      apply: '開票',
      table: {
        id: '編號',
        invoiceKind: '發票種類',
        invoiceType: '發票類型',
        ownerName: '業主名稱',
        roomName: '房屋編號',
        applicant: '申請人',
        invoiceName: '發票名頭',
        taxNumber: '納稅人識別號',
        addressPhone: '地址、電話',
        amount: '申請金額',
        invoiceCode: '發票號',
        submitState: '提交結果',
        mallState: '商城狀態',
        failReason: '失敗原因',
        applyTime: '申請時間',
        invoicePdf: '發票PDF'
      },
      mallState: {
        AUDIT: '待審核',
        WAIT: '待開票',
        DONE: '開票成功',
        FAIL: '開票失敗',
        RED: '已沖紅'
      },
      submitStateAll: '全部',
      submitStateSubmit: '已提交',
      submitStateFail: '提交失敗',
      personal: '個人',
      company: '企業',
      invoiceKindAll: '全部',
      invoiceTypeAll: '全部',
      normalInvoice: '普票',
      specialInvoice: '專票',
      notUploaded: '未上傳',
      downloadInvoice: '下載發票',
      noInvoicePdf: '暫無發票',
      reSubmit: '重新提交',
      submitSuccess: '已提交',
      submitFailed: '提交失敗',
      invoiceCodePlaceholder: '請填寫發票號',
      invoiceKindPlaceholder: '請選擇發票種類',
      invoiceTypePlaceholder: '請選擇發票類型',
      ownerNamePlaceholder: '請填寫業主名稱',
      applicantPlaceholder: '請填寫申請人',
      phonePlaceholder: '請填寫申請人電話',
      roomNamePlaceholder: '請填寫房屋編號',
      roomFilterTitle: '房屋篩選',
      allRooms: '全部房屋',
      tabInvoice: '發票管理',
      tabInvoiceRed: '發票紅沖',
      invoiceRed: '紅沖',
      redTitle: '發票紅沖列表',
      redDialogTitle: '發起紅沖',
      redReason: '紅沖原因',
      redReasonPlaceholder: '請選擇紅沖原因',
      redReasonRequired: '請選擇紅沖原因',
      redReasonOptions: {
        invoiceError: '開票有誤',
        salesReturn: '銷售退回',
        serviceStop: '服務終止',
        other: '其他'
      },
      redRemark: '備註',
      redRemarkPlaceholder: '請填寫備註(選填)',
      confirmRed: '確認紅沖',
      redSuccess: '紅沖申請已提交',
      redFailed: '紅沖未完成, 可在商城後台重試',
      redEmptyTip: '暫無紅沖數據',
      redState: {
        WAIT: '待沖紅',
        DONE: '已沖紅'
      },
      redTable: {
        applyId: '申請單號',
        redId: '紅沖單號',
        invoiceNo: '發票號碼',
        buyerName: '購買方',
        amount: '紅沖金額',
        reason: '紅沖原因',
        remark: '備註',
        state: '狀態',
        redNo: '紅字發票號碼',
        createTime: '時間'
      }
    },
    deleteInvoiceApply: {
      title: '請確認您的操作',
      confirmMessage: '確定刪除申請發票'
    },
    uploadImage: {
      sizeLimit: '圖片大小不能超過 2MB'
    }
  }
}
